import React from "react";
import ReactSpeedometer from "react-d3-speedometer";

function Speedometer({ time }) {
  return (
    <div style={{ width: "200px", height: "160px", overflow: "hidden", margin: "0 auto" }}>
      <ReactSpeedometer
        width={200}                // <-- fixed width
        maxValue={150}
        value={time}
        needleColor="black"
        startColor="#1b9506"
        endColor="#f40909"
        needleHeightRatio={0.5}
        ringWidth={8}
        minValue={0}
        segmentColors={["#1b9506", "#ffba00", "#f40909"]}
        needleTransitionDuration={4000}
        needleTransition="easeElastic"
        currentValueText=""
        customSegmentStops={[0, 75, 120, 150]}
      />
    </div>
  );
}

export default Speedometer;
